module.exports = __webpack_public_path__ + "img/weibaoReport3.5be2894c.png";